<template>
<div id="app">
  <!-- <keep-alive :include="'newHome'"> -->
    <router-view></router-view>
  <!-- </keep-alive> -->
</div>

</template>

<script>
import { getToken } from "@/utils/cache";

export default {

  name: 'App',
  data() {
    return {
      active: "0",
      scope: "scope.mobile",
      isShow: false
    }
  },
  //初始化页面选中状态
  mounted() {
    console.log("初始化页面..")
    this.checkToken()
  },
  methods: {
    checkToken(){
      // const token = getToken()
      // console.log(token)
      // if(token) {
      //   console.log("toIndex..")
      //   this.$router.replace('/index')
      // }
      this.$router.replace('/index')
      // else{
      //   console.log("toLogin..")
      //   this.$router.push('/login')
      // }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 10px;
  /* background-image: url(./assets/bg1.png); */
  background-repeat: no-repeat;
  background-size: 100% 160px;
  max-width: 100%;
  overflow-x: hidden;
  background-color: #F8F8F8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue